export default {
  small: 'small',
  medium: 'medium',
  large: 'large',
};
